import React, { Component } from "react";

export default class Empty extends Component {
	render() {
		return (
			<div className="ladder-empty-detail">
				<h3>无法获取角色资料</h3>
				<h4>该角色资料无法显示，可能是以下某个原因：</h4>
				<ul>
					<li><i>1</i>我们无法从官方接口获取数据</li>
					<li><i>2</i>该角色长时间没有活跃</li>
				</ul>
			</div>
		);
	}
}